import { render, staticRenderFns } from "./Services2.vue?vue&type=template&id=1e6ec758&scoped=true"
import script from "./Services2.vue?vue&type=script&lang=ts"
export * from "./Services2.vue?vue&type=script&lang=ts"
import style0 from "./Services2.vue?vue&type=style&index=0&id=1e6ec758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ec758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
